import { render, staticRenderFns } from "./NewInstitutionPage.vue?vue&type=template&id=25f7c0f0&"
import script from "./NewInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./NewInstitutionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports